import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/src/components/Button';
import { useUserContext } from '../../../../contexts/user-context';
import s from './CloseModal.module.scss';

const propTypes = {
  onCancelClick: PropTypes.func.isRequired,
  onExitClick: PropTypes.func.isRequired,
};

const CloseModal = ({ onCancelClick, onExitClick }) => {
  const { isLoggedIn } = useUserContext();
  return (
    <div className={s.root}>
      <div className={s.closeModal}>
        <div className={s.modalTitle}>Are you sure?</div>
        {isLoggedIn && (
          <div className={s.modalText}>
            Don&apos;t worry — your progress will be saved for later.
          </div>
        )}
        <div className={s.buttons}>
          <Button
            type="secondary"
            label="CANCEL"
            tabIndex="-1"
            onClick={() => {
              onCancelClick();
            }}
          />
          <Button
            label="EXIT"
            tabIndex="-1"
            onClick={() => {
              onExitClick();
            }}
          />
        </div>
      </div>
    </div>
  );
};

CloseModal.propTypes = propTypes;
export default CloseModal;
